import React, { FC } from 'react';
import classnames from 'classnames';
import { ColouredTagProps } from './props';
import './styles.scss';

export const ColouredTag: FC<ColouredTagProps> = ({ text, colour, className }) => {
  return (
    <div className={classnames('coloured-tag', `coloured-tag--${colour}`, className)}>
      <div className={classnames('coloured-tag__bubble', `coloured-tag__bubble--${colour}`)} />
      <div className={classnames('coloured-tag__label', `coloured-tag__label--${colour}`)}>{text}</div>
    </div>
  );
};
